import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

import Login from '../views/Login';
import Class from '../views/Class';
import Student from '../views/Student';
import Student2 from '../views/Student_2';
import StudentView from '../views/StudentView';
import Firstlogin from '../views/Firstlogin';
import Recover from '../views/Recover';
import Reexam from '../views/Reexam';
import ReexamAddEdit from '../views/ReexamAddEdit';
import StudentReexam from '../views/Studentreexam';
import Lock from '../views/Lock';
import LockAddEdit from '../views/LockAddEdit';
import Roles from '../views/Roles';
import RolesAddEdit from '../views/RolesAddEdit';
import Objection from '../views/Objection';
import ClassVoorzitter from '../views/ClassVoorzitter';
import Personalia from '../views/Personalia';
import Studentberoep from '../views/Studentberoep';
import Studentberoepvoorzitter from '../views/StudentberoepVoorzitter';
import Main from '../views/Main';
import StudentVoorzitter from '../views/StudentVoorzitter';
import Eindresultaat from '../views/Eindresultaat';
import ObjectionResults from '../views/ObjectionResults';
import Reports from '../views/Reports';
import OKRconfig from '../views/OKRconfig';
import OKRconfigAddEdit from '../views/OKRconfigAddEdit';


export default new Router({
  //mode: 'history',
  linkActiveClass: "active",
  routes: [{
    path: '/',
    components: {
      login: Login
    }
  }, {
    path: '/recover',
    components: {
      login: Recover
    }
  }, {
    path: '/firstlogin',
    components: {
      login: Firstlogin
    }
  }, {
    path: '/okr',
    components: {
      main: Main
    },
    children: [{
      path: '',
      components: {
        content: Class
      }
    }, {
      path: '/roles',
      components: {
        content: Roles
      }
    },{
      path: '/roles/new',
      components: {
        content: RolesAddEdit
      },
      props: {
        content: true
      }
    },{
      path: '/roles/update/:id',
      components: {
        content: RolesAddEdit
      },
      props: {
        content: true
      }
    },{
      path: '/lock',
      components: {
        content: Lock
      }
    },{
      path: '/lock/new',
      components: {
        content: LockAddEdit
      },
      props: {
        content: true
      }
    },{
      path: '/lock/update/:id',
      components: {
        content: LockAddEdit
      },
      props: {
        content: true
      }
    }, {
      path: '/beroepresultaat',
      components: {
        content: ObjectionResults
      }
    }, {
      path: '/eindresultaat',
      components: {
        content: Eindresultaat
      }
    }, {
      path: '/objection',
      components: {
        content: Objection
      }

    }, {
      path: '/studentvoorzitter/:id',
      components: {
        content: StudentVoorzitter
      }
    }, {
      path: '/okrvoorzitter',
      components: {
        content: ClassVoorzitter
      }
    }, {
      path: '/reports',
      components: {
        content: Reports
      }
    }, {
      path: '/okrconfig/new',
      components: {
        content: OKRconfigAddEdit
      },
      props: {
        content: true
      }
    }, {
      path: '/okrconfig/update/:id',
      components: {
        content: OKRconfigAddEdit
      },
      props: {
        content: true
      }
    }, {
      path: '/okrconfig',
      components: {
        content: OKRconfig
      }
    }, {
      path: '/student_personalia',
      components: {
        content: Personalia
      }
    }, {
      path: '/student/:id',
      components: {
        content: Student
      }
    }, {
      path: '/studentreexam',
      components: {
        content: StudentReexam
      }
    }, {
      path: '/studentreexam/:id',
      components: {
        content: StudentReexam
      },
      props: {
        content: true
      }
    },{
      path: '/reexam',
      components: {
        content: Reexam
      }
    }, {
      path: '/reexam/:id',
      components: {
        content: ReexamAddEdit
      },
      props: {
        content: true
      }
    }, {
      path: '/student2/:id',
      components: {
        content: Student2
      }
    }, {
      path: '/studentberoep/:id',
      components: {
        content: Studentberoep
      }
    }, {
      path: '/studentberoepvoorzitter/:id',
      components: {
        content: Studentberoepvoorzitter
      }
    }, {
      path: '/studentview/:id',
      components: {
        content: StudentView
      }
    }]
  }, ]
})


//studentberoepvoorzitter
